export const lastRenderedSlug = (): string => {
  const route = window.location.pathname;

  const regex = '/vaga/(.+)';

  const matched = String(route).match(regex);

  return matched ? matched[1] : '';
};
